<template>
  <div class="news_zx">
    <!-- 新闻资讯 -->
    <!-- nav -->
    <index-nav></index-nav>
     <!-- bottom -->
    <index-bottom></index-bottom>
    <div class="content">
      <!-- banner -->
      <div class="banner">
        <img src="/statics/images/info/news_banner.jpg" alt />
      </div>
      <div class="newsInfo inner">
        <!-- 子导航 -->
        <div class="childnav">
          <div class="desc">
            <img src="/statics/images/info/icon.png" alt />
            <span>新闻列表</span>
          </div>
          <el-tabs :tab-position="tabPosition" v-model="activeChildname" @tab-click="handleClick">
            <!-- :name="item.id" -->
            <el-tab-pane
              v-for="(item,index) in cateList"
              :key="index"
              :label="item.name"
              :name="(item.id).toString()"
            ></el-tab-pane>
            <!-- <el-tab-pane label="行业新闻" name="two"></el-tab-pane>
            <el-tab-pane label="专题报道" name="three"></el-tab-pane>
            <el-tab-pane label="最新公告" name="four"></el-tab-pane>-->
          </el-tabs>
        </div>
        <!-- activeChildname =='one'新闻列表 -->
        <div class="news_right" v-if="activeChildname!=4">
          <!-- 下载列表 -->
          <div class="news_list">
            <div
              class="news_item"
              v-for="(item,index) in newsList"
              :key="index"
              @click="toInfo(item.id)"
            >
              <div class="news_pic">
                <img :src="adddom(item.thumb)" alt />
              </div>
              <div class="news_con">
                <h3>{{item.title}}</h3>
                <p class="slhs">{{item.desc}}</p>
                <div class="clearfix">
                  <img class="f-r" src="/statics/images/info/jiantou.png" alt />
                </div>
                <span>{{item.created_at}}</span>
              </div>
            </div>
          </div>
          <!-- 分页 -->
          <div class="fenye clearfix" v-if="newsList.length!=0">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pages.size"
              layout="prev, pager, next, jumper"
              :total="newsTotal"
              prev-text="上一页"
              next-text="下一页"
            ></el-pagination>
          </div>
        </div>
        <!-- activeChildname =='four' 公告-->
        <div class="news_right" v-else>
          <div class="gg_list">
            <!-- <div class="gg_item act">
              <div class="gg">
                <span>[公告] 详细分析排烟风机怎么会渗水?</span>
              </div>
              <div class="time">
                <span>2022年2月26日</span>
                <img src="/statics/images/info/gg_jiantou.png" alt />
              </div>
            </div>-->
            <div
              class="gg_item"
              v-for="(item,index) in newsList"
              :key="index"
              @click="toInfo(item.id)"
            >
              <div class="gg">
                <span>[公告] {{item.title}}</span>
              </div>
              <div class="time">
                <span>{{item.created_at}}</span>
                <img src="/statics/images/info/gg_jiantou.png" alt />
              </div>
            </div>
          </div>
          <!-- 分页 -->
          <div class="fenye clearfix">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pages.size"
              layout="prev, pager, next, jumper"
              :total="newsTotal"
              prev-text="上一页"
              next-text="下一页"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- bottom -->
    <!-- <index-bottom></index-bottom> -->
    <!-- footer -->
    <index-footer></index-footer>
  </div>
</template>

<script>
import indexNav from "./../components/nav";
import indexBottom from "./../components/bottom";
import indexFooter from "./../components/footer";
export default {
  data() {
    return {
      cateList: [], //新闻分类
      newsList: [], //新闻列表
      activeChildname: "", //子导航
      tabPosition: "left", //子导航对齐方式
      currentPage: 1, //当前页数
      // currentPagefour: 1, //当前页数
      cateId: "",
      newsTotal: 0, //总条数
      pages: {
        page: 1,
        size: 10
      },
      fromName:""
    };
  },
  components: {
    indexNav,
    indexBottom,
    indexFooter
  },
  created() {
    // 新闻分类
    this.getCate();
  },
  methods: {
    // 图片拼接地址
    adddom(src) {
      if (src == "" || src == undefined || src == null) {
        console.log("src地址有问题");
        return "";
      }
      if (src.substr(0, 4).toLowerCase() === "http") {
        return src;
      }
      return this.$url + src;
    },
    getCate() {
      var that = this;
      that.$api.index.newsCate({}).then(function(res) {
        if (res.code == 200) {
          that.cateList = res.result;
          that.activeChildname = that.cateList[0].id.toString();
          that.cateId = that.activeChildname;
          that.getList();
        }
      });
    },
    getList() {
      var that = this;
      var ps = {
        cate_id: that.cateId,
        page: that.pages.page,
        size: that.pages.size
      };
      that.$api.index.newsList(ps).then(function(res) {
        if (res.code == 200) {
          that.newsTotal = res.result.total;
          that.newsList = res.result.list;
        }
      });
    },
    // 页数改变时触发
    handleCurrentChange(val) {
      // console.log(val);
      this.pages.page = val;
      this.getList();
    },
    // // 页数改变时触发
    // handleCurrentChangefour(val) {
    //   console.log(val);
    // },
    // 子导航选中触发
    handleClick(tab) {
      // console.log(tab.name);
      this.activeChildname = tab.name;
      this.cateId = this.activeChildname;
      this.currentPage = 1;
      this.pages.page = 1;
      this.getList();
    },
    // 点击跳转到新闻资讯详情
    toInfo(id) {
      this.$router.push({
        path: "/news_zxinfo",
        query: {
          id: id
        }
      });
    }
  },
  mounted: function() {},
    watch: {
    $route(to, from) {
      // console.log("to", to);
      // console.log("from", from);
      this.fromName = from.name;
    }
  },
  activated: function() {
    // console.log(this.fromName);
    if(this.fromName!="news-zxinfo"){
      this.getCate();
    }
  }
};
</script>

<style>
</style>